import { GameOrientationEnum } from '@/types/game-orientation';
import { atom } from 'jotai';

/* @des casino是否在游戏中 */
export const isCasinoInGameAtom = atom<boolean>(false);
/* @des casino游戏横竖屏 */
export const casinoGameOrientationAtom = atom<GameOrientationEnum>(GameOrientationEnum.Portrait);

export const resetCasinoAtomsAtom = atom(null, (_get, set) => {
  set(isCasinoInGameAtom, false);        // 重置为初始值 false
  set(casinoGameOrientationAtom, GameOrientationEnum.Portrait); // 重置为初始值 GameOrientationEnum.Portrait
});